import { render, staticRenderFns } from "./JobDetalhar.vue?vue&type=template&id=340b852c"
import script from "./JobDetalhar.vue?vue&type=script&lang=js"
export * from "./JobDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports